module.exports = "https://static.wmbcdn.com/uniweb/images/8ee382e2bc7ba66cacb8d82c3e33d07d.png";